module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_1.39f57ce0.png";